const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

type RotationLike = { _id: string; date: string | Date };
type SessionLike = {
  rotation?: string;
  selectedDates?: (string | Date)[];
};

export const getRecencyCutoff = (now: Date = new Date()): Date =>
  new Date(now.getTime() - ONE_MONTH_MS);

export const isRecentRotation = (r: RotationLike, cutoff: Date): boolean =>
  new Date(r.date).getTime() >= cutoff.getTime();

export const isRecentSession = (
  s: SessionLike,
  rotations: RotationLike[],
  cutoff: Date,
): boolean => {
  const dates = (s.selectedDates ?? [])
    .map((d) => new Date(d).getTime())
    .filter((t) => !Number.isNaN(t));

  if (dates.length > 0) {
    return Math.max(...dates) >= cutoff.getTime();
  }

  const rotation = rotations.find((r) => r._id === s.rotation);
  if (rotation) {
    return new Date(rotation.date).getTime() >= cutoff.getTime();
  }

  return true;
};
